import { Text, Flex } from "@chakra-ui/react"
import * as React from "react"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { usersSelector } from "../../../recoil/atoms/users"
import { findThePercentage } from "../../../util"
import { UserAvatar } from "../../common/avatar"
import { ChatPollProps } from "./polls.interfaces"
import {
  ChatPollContainer,
  ChatPollTitle,
  NameContainer,
  PercentageVariantContainer,
  PollTextTipCounter,
  Scale,
  TimeContainer,
  UserInfoContainer,
  VariantButtonContainer,
  VariantButtonText,
  VariantContainer,
  VariantDataContainer,
  VariantsButtonsContainer,
  VariantsContainer,
  VariantsWrapper,
  VariantText,
  VariantWrapper
} from "./polls.styled"
import { SDKContext } from "../../../context/SDKContext"
import * as Util from "../../../util"
import { OverflownText } from "../../common/overflown-text"
import { Icon } from "../../common/icons"
import { IoClose } from "react-icons/io5"
import { pollsSelector } from "../../../recoil/atoms/polls"
import { useTranslation } from "react-i18next"
import { IconButton } from "../../common/buttons"
import { stringifyPollOption } from "../../../util/poll-util"
import { AiOutlineArrowDown } from "react-icons/ai"
import { viewDependingLayoutAtom } from "../../../recoil/atoms/view"
import { PollArrows } from "./poll-arrows"
import { waitForElm } from "../../../util/waitForElm"

const _ChatPoll: React.FC<ChatPollProps> = ({
  poll,
  isFullScreen,
  isMobile,
  isLandscape
}) => {
  const { isTablet } = useRecoilValue(viewDependingLayoutAtom)
  const [timeStamp, setTimeStamp] = React.useState({
    start: 0,
    end: 0
  })

  const { t } = useTranslation()
  const meetingClient = React.useContext(SDKContext)
  const containerRef = React.useRef(null)
  const [isArrow, setArrow] = React.useState(false)
  const [isArrows, setArrows] = React.useState(false)
  const authorPoll = useRecoilValue(usersSelector(poll?.author?.id))
  const setPolls = useSetRecoilState(pollsSelector)
  const voiceInLocalStorage = () => {
    if (sessionStorage.getItem("polls")) {
      return Object.values(
        JSON.parse(sessionStorage.getItem("polls"))
      ).includes(poll!.id)
    }
    return false
  }

  const [isVoteUser, setIsVoteUser] = React.useState(voiceInLocalStorage)
  const roomStyles = useRecoilValue(brandingSelector)

  const counter = `${poll!.totalResponses} ${
    poll!.totalResponses === 1 ? t("vote") : t("votes")
  }`

  const handleVote = React.useCallback(
    (index, choise): void => {
      const option = stringifyPollOption(index + 1, choise)
      meetingClient?.voteInThePoll(poll?.id, option)
      const pollId = poll?.id
      const key = `pollId-${pollId}`

      let history = {}
      const storedJSONStr = sessionStorage.getItem("polls")

      if (storedJSONStr) {
        history = JSON.parse(storedJSONStr)
      }

      const data = {
        [`${key}`]: pollId
      }
      history = Object.assign(history, data)
      sessionStorage.setItem("polls", JSON.stringify(history))
      setIsVoteUser(true)
    },
    [meetingClient, poll?.id]
  )

  const handleClosePoll = React.useCallback(() => {
    setPolls({
      type: "TOGGLE_POLL_MOBILE",
      payload: { id: poll?.id, isVisibleMobile: false }
    })
  }, [poll?.id, setPolls])

  const handleTouchStart = e => {
    setTimeStamp({ ...timeStamp, start: e.timeStamp })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = () => {
    const container = containerRef.current
    if (container) {
      const scrollTop = container.scrollTop
      const totalHeight = container.scrollHeight
      const visibleHeight = container.offsetHeight
      const isAtTop = scrollTop === 0
      const isAtBottom = scrollTop + visibleHeight >= totalHeight

      if (container.scrollHeight > container.clientHeight) {
        if (isAtTop) {
          setArrow(true)
        } else if (isAtBottom) {
          setArrow(false)
        }
        setArrows(true)
        didablew(isAtTop, isAtBottom)
      } else {
        setArrows(false)
        setArrow(false)
      }
    }
  }

  const handleTouchEnd = React.useCallback(
    (e, index, choice) => {
      if (e.timeStamp - timeStamp.start < 150) {
        handleVote(index, choice)

        let timer = setTimeout(() => {
          handleScroll()
        }, 300)
        return () => clearTimeout(timer)
      }
      setTimeStamp({ start: 0, end: 0 })
    },
    [handleScroll, handleVote, timeStamp.start]
  )

  const didablew = React.useCallback(
    async (isAtTop, isAtBottom) => {
      const upSvgElement = (await waitForElm(
        `arrow-up-${poll?.id}`
      )) as HTMLElement
      const downSvgElement = (await waitForElm(
        `arrow-down-${poll?.id}`
      )) as HTMLElement

      if (downSvgElement) {
        if (isAtBottom) {
          downSvgElement.style.opacity = "0.5"
        } else {
          downSvgElement.style.opacity = "1"
        }
      }

      if (upSvgElement) {
        if (isAtTop) {
          upSvgElement.style.opacity = "0.5"
        } else {
          upSvgElement.style.opacity = "1"
        }
      }
    },
    [poll?.id]
  )

  React.useEffect(() => {
    const container = containerRef.current

    /*   const handleScroll = () => {
      const container = containerRef.current
      if (container) {
        const scrollTop = container.scrollTop
        const totalHeight = container.scrollHeight
        const visibleHeight = container.offsetHeight
        const isAtTop = scrollTop === 0
        const isAtBottom = scrollTop + visibleHeight >= totalHeight
        if (container.scrollHeight > container.clientHeight) {
          if (isAtTop) {
            setArrow(true)
          } else if (isAtBottom) {
            setArrow(false)
          }
          setArrows(true)
          didablew(isAtTop, isAtBottom)
        } else {
          setArrows(false)
          setArrow(false)
        }
      }
    } */

    container.addEventListener("scroll", handleScroll)
    handleScroll()

    return () => {
      container.removeEventListener("scroll", handleScroll)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ChatPollContainer
      key={`chat-poll-${poll?.id}`}
      isFullScreen={isFullScreen || isLandscape}
      roomStyles={roomStyles}
      style={{ borderWidth: isFullScreen && "1px" }}
    >
      {isMobile && isArrow && !isFullScreen && !isLandscape && (
        <Icon
          src={AiOutlineArrowDown}
          fontSize="1.5rem"
          bottom="20px"
          left="6px"
          pos="absolute"
          color={roomStyles?.servicePanelElementBorder}
        />
      )}
      {isMobile && isFullScreen && isArrows && (
        <PollArrows containerRef={containerRef} pollId={poll?.id} />
      )}
      {isMobile && (
        <IconButton
          pos="absolute"
          width="21px"
          height="21px"
          right={"4.8px"}
          top={"4.8px"}
          isMobile={isMobile}
          onClick={handleClosePoll}
        >
          <Flex
            width="21px"
            height="21px"
            borderRadius="50%"
            alignItems="center"
            justifyContent="center"
            backgroundColor={roomStyles?.secondaryAccessButtonBackgroundColor}
            border={
              roomStyles?.secondaryAccessButtonBorderColor
                ? `1px solid ${
                    roomStyles?.secondaryAccessButtonBorderColor
                      ? roomStyles.secondaryAccessButtonBorderColor
                      : "transparent"
                  }`
                : "0px"
            }
            textColor={roomStyles?.secondaryAccessButtonTextColor ?? "#FFFFFF"}
            _hover={{
              backgroundColor:
                roomStyles?.secondaryAccessButtonMouseoverColor ?? "#24A840",
              textColor:
                roomStyles?.secondaryAccessButtonTextMouseoverColor ?? "#FFFFFF"
            }}
            cursor={"pointer"}
            zIndex={1}
          >
            <Icon
              src={IoClose}
              fontSize="0.8rem"
              marginRight="-50%"
              transform="translate(-50%, -50%)"
              top="50%"
              left="50%"
              pos="absolute"
            />
          </Flex>
        </IconButton>
      )}

      <UserInfoContainer>
        <UserAvatar
          name={poll?.author?.name}
          size="xs"
          avatarStyle={{ width: "1.5rem", height: "1.5rem" }}
          avatar={poll?.author?.avatar}
          colorDisk={authorPoll?.color}
          src={poll?.author?.avatar}
        />

        <NameContainer>
          <Text
            fontSize="sm"
            fontWeight="medium"
            color={
              isFullScreen || isLandscape
                ? "white"
                : roomStyles?.servicePanelElementPrimaryText ?? "#718096"
            }
            opacity={(isFullScreen || isLandscape) && "0.7"}
          >
            {poll?.author?.name}
          </Text>
        </NameContainer>
        <TimeContainer>
          <Text
            fontSize="0.75rem"
            marginRight={isMobile && "26px"}
            color={
              isFullScreen || isLandscape
                ? "white"
                : roomStyles?.servicePanelElementLabels
            }
            opacity={(isFullScreen || isLandscape) && "0.7"}
          >
            {Util.formatTime24h(poll!.timestamp)}
          </Text>
        </TimeContainer>
      </UserInfoContainer>

      <ChatPollTitle
        isFullScreen={isFullScreen || isLandscape}
        roomStyles={roomStyles}
        style={{ marginBottom: isMobile ? "0.4rem" : "0px" }}
      >
        {poll?.title}
      </ChatPollTitle>
      <div
        ref={containerRef}
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: isMobile && "100px",
          overflowY: isMobile ? "auto" : "visible"
        }}
        id="poll-options-wrapper"
      >
        {isVoteUser ? (
          <VariantsWrapper isMobile={isMobile}>
            <VariantsContainer style={{ marginTop: isMobile && "0rem" }}>
              {poll?.choices.map((el, index) => {
                const percentage = findThePercentage(
                  poll!.totalResponses,
                  el.vote
                )

                return (
                  <VariantWrapper
                    key={index}
                    style={{
                      marginBottom:
                        isMobile && poll.choices.length - 1 === index && "0px"
                    }}
                  >
                    <VariantContainer roomStyles={roomStyles}>
                      <Scale
                        percentage={percentage}
                        isFullScreen={isFullScreen || isLandscape}
                        roomStyles={roomStyles}
                      />
                      <VariantDataContainer
                        noVote={el.vote === 0}
                        roomStyles={roomStyles}
                        isFullScreen={isFullScreen || isLandscape}
                      >
                        <VariantText
                          isFullScreen={isFullScreen || isLandscape}
                          numberVotes={el.vote}
                          roomStyles={roomStyles}
                        >
                          <OverflownText
                            display="flex"
                            alignItems="center"
                            height="100%"
                          >
                            {el.choice}
                          </OverflownText>
                        </VariantText>{" "}
                      </VariantDataContainer>
                    </VariantContainer>

                    <PercentageVariantContainer
                      roomStyles={roomStyles}
                      isFullScreen={isFullScreen || isLandscape}
                    >{`${Math.trunc(percentage)}%`}</PercentageVariantContainer>
                  </VariantWrapper>
                )
              })}
            </VariantsContainer>
          </VariantsWrapper>
        ) : (
          <>
            <VariantsButtonsContainer
              isMobile={isMobile}
              style={{ maxHeight: isMobile && "100px" }}
            >
              {poll?.choices.map((el, index) => (
                <VariantButtonContainer
                  key={index}
                  roomStyles={roomStyles}
                  onClick={
                    isMobile && !isTablet
                      ? undefined
                      : e => handleVote(index, el.choice)
                  }
                  onTouchStart={handleTouchStart}
                  onTouchEnd={
                    isMobile && !isTablet
                      ? e => handleTouchEnd(e, index, el.choice)
                      : undefined
                  }
                  isMobile={isMobile && !isTablet}
                  style={{
                    marginBottom:
                      isMobile && poll.choices.length - 1 === index && "0px"
                  }}
                >
                  <VariantButtonText
                    roomStyles={roomStyles}
                    isMobile={isMobile && !isTablet}
                  >
                    {el.choice}
                  </VariantButtonText>
                </VariantButtonContainer>
              ))}
            </VariantsButtonsContainer>
          </>
        )}
      </div>
      <PollTextTipCounter
        roomStyles={roomStyles}
        isFullScreen={isFullScreen || isLandscape}
        style={{ marginTop: isMobile ? "0.4rem" : "0px" }}
      >
        {counter}
      </PollTextTipCounter>
    </ChatPollContainer>
  )
}

export const ChatPoll = _ChatPoll
